export const toTableRowItems = (items: AdminStore[]) =>
  items.map((item: AdminStore) => ({
    id: item.id,
    metiCode: item.metiCode || '',
    metiName: item.metiName || '',
    metiType: item.metiType || '',
    metiVersion: item.metiVersion || '',
    adCode: item.adCode || '',
    receptionDeviation: item.receptionDeviation,
    regionNames: item.regionNames || '',
    sftpIp: item.sftpIp || '',
    sftpPath: item.sftpPath || '',
    metiGrappe: item.metiGrappe || '',
    canEditQuantities: item.canEditQuantities || '',
    active: item.active,
    address: item.address || '',
    city: item.city || '',
    town: item.town || '',
    regNumber: item.regNumber || '',
    cif: item.cif || '',
    office: item.office || '',
    bankName: item.bankName || '',
    bankAccount: item.bankAccount || '',
    capital: item.capital || '',
    hourlyIntervals: item.hourlyIntervals || 0,
    canCallReturnTruck: item.canCallReturnTruck || false,
    parentSociety: item.parentSociety || ''
  }))
